 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"index": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"index": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"NfCustomer-List-vue~NfCustomer-View-vue~NfProduct-List-vue~NfProduct-View-vue~Purchase-List-vue~Purc~f52c411e":"NfCustomer-List-vue~NfCustomer-View-vue~NfProduct-List-vue~NfProduct-View-vue~Purchase-List-vue~Purc~f52c411e","NfCustomer-List-vue~NfProduct-List-vue~Purchase-List-vue":"NfCustomer-List-vue~NfProduct-List-vue~Purchase-List-vue","NfCustomer-List-vue":"NfCustomer-List-vue","NfProduct-List-vue":"NfProduct-List-vue","Purchase-List-vue":"Purchase-List-vue","NfCustomer-View-vue~NfProduct-View-vue~Purchase-View-vue":"NfCustomer-View-vue~NfProduct-View-vue~Purchase-View-vue","NfCustomer-View-vue~NfProduct-View-vue":"NfCustomer-View-vue~NfProduct-View-vue","NfCustomer-View-vue":"NfCustomer-View-vue","NfProduct-View-vue":"NfProduct-View-vue","Purchase-View-vue":"Purchase-View-vue","Records-Customers-List-vue":"Records-Customers-List-vue","Records-Products-List-vue":"Records-Products-List-vue","Records-Products-View-vue":"Records-Products-View-vue","Overview-vue":"Overview-vue","Records-Couriers-vue":"Records-Couriers-vue","Records-Customers-View-vue":"Records-Customers-View-vue","Records-Suppliers-vue":"Records-Suppliers-vue"}[chunkId]||chunkId) + "." + {"NfCustomer-List-vue~NfCustomer-View-vue~NfProduct-List-vue~NfProduct-View-vue~Purchase-List-vue~Purc~f52c411e":"1d18d327","NfCustomer-List-vue~NfProduct-List-vue~Purchase-List-vue":"98ded81a","NfCustomer-List-vue":"7d886e37","NfProduct-List-vue":"64261bf5","Purchase-List-vue":"30aa7dd6","NfCustomer-View-vue~NfProduct-View-vue~Purchase-View-vue":"74aae291","NfCustomer-View-vue~NfProduct-View-vue":"6940b72f","NfCustomer-View-vue":"bc3679c6","NfProduct-View-vue":"443cb342","Purchase-View-vue":"cd4721c2","Records-Customers-List-vue":"3547e99b","Records-Products-List-vue":"97fa4504","Records-Products-View-vue":"1f90bfef","Overview-vue":"cdbf16a3","Records-Couriers-vue":"a93f9056","Records-Customers-View-vue":"6c943dbd","Records-Suppliers-vue":"477c0497"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"NfCustomer-List-vue~NfCustomer-View-vue~NfProduct-List-vue~NfProduct-View-vue~Purchase-List-vue~Purc~f52c411e":1,"NfCustomer-List-vue~NfProduct-List-vue~Purchase-List-vue":1,"NfCustomer-List-vue":1,"NfProduct-List-vue":1,"NfCustomer-View-vue~NfProduct-View-vue~Purchase-View-vue":1,"NfCustomer-View-vue~NfProduct-View-vue":1,"NfProduct-View-vue":1,"Purchase-View-vue":1,"Records-Customers-List-vue":1,"Records-Products-List-vue":1,"Records-Customers-View-vue":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"NfCustomer-List-vue~NfCustomer-View-vue~NfProduct-List-vue~NfProduct-View-vue~Purchase-List-vue~Purc~f52c411e":"NfCustomer-List-vue~NfCustomer-View-vue~NfProduct-List-vue~NfProduct-View-vue~Purchase-List-vue~Purc~f52c411e","NfCustomer-List-vue~NfProduct-List-vue~Purchase-List-vue":"NfCustomer-List-vue~NfProduct-List-vue~Purchase-List-vue","NfCustomer-List-vue":"NfCustomer-List-vue","NfProduct-List-vue":"NfProduct-List-vue","Purchase-List-vue":"Purchase-List-vue","NfCustomer-View-vue~NfProduct-View-vue~Purchase-View-vue":"NfCustomer-View-vue~NfProduct-View-vue~Purchase-View-vue","NfCustomer-View-vue~NfProduct-View-vue":"NfCustomer-View-vue~NfProduct-View-vue","NfCustomer-View-vue":"NfCustomer-View-vue","NfProduct-View-vue":"NfProduct-View-vue","Purchase-View-vue":"Purchase-View-vue","Records-Customers-List-vue":"Records-Customers-List-vue","Records-Products-List-vue":"Records-Products-List-vue","Records-Products-View-vue":"Records-Products-View-vue","Overview-vue":"Overview-vue","Records-Couriers-vue":"Records-Couriers-vue","Records-Customers-View-vue":"Records-Customers-View-vue","Records-Suppliers-vue":"Records-Suppliers-vue"}[chunkId]||chunkId) + "." + {"NfCustomer-List-vue~NfCustomer-View-vue~NfProduct-List-vue~NfProduct-View-vue~Purchase-List-vue~Purc~f52c411e":"6fa0c4b8","NfCustomer-List-vue~NfProduct-List-vue~Purchase-List-vue":"84b3c5ea","NfCustomer-List-vue":"8c3a4b6d","NfProduct-List-vue":"6516a970","Purchase-List-vue":"31d6cfe0","NfCustomer-View-vue~NfProduct-View-vue~Purchase-View-vue":"2c02fc2d","NfCustomer-View-vue~NfProduct-View-vue":"24371707","NfCustomer-View-vue":"31d6cfe0","NfProduct-View-vue":"50b41d61","Purchase-View-vue":"a98cf4f6","Records-Customers-List-vue":"f2a13040","Records-Products-List-vue":"c6824d89","Records-Products-View-vue":"31d6cfe0","Overview-vue":"31d6cfe0","Records-Couriers-vue":"31d6cfe0","Records-Customers-View-vue":"50b41d61","Records-Suppliers-vue":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
